import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseProvider } from '../BaseProvider';
import { LoginResponseModel, CompanyProfileModel, RateAlertModel, BaseRateModel } from '../../_models/index';
import { GlobalService } from '../../_global/global.service';

@Injectable()
export class GeneratlConfigurationService extends BaseProvider {

    partnerId: string;
    resource = 'rateRules/';

    constructor(private http: Http, private _gs: GlobalService) {
        super(http);
        this.partnerId = this._gs.currentUser.partner.id;
    }

    getEmailMobileConfig() {
        return this.makeGetCall('listofEmailMobile');
    }

    editEmailMobileConfig(description, id, value) {
        var resourceUrl = 'addEmailMobile?description=';
        return this.makePutCall(resourceUrl + description + '&id=' + id + '&value=' + value, value)
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/generalConfiguration/generalConfiguration.service.ts